import { render, staticRenderFns } from "./Festival.vue?vue&type=template&id=423b0d31&scoped=true"
import script from "./Festival.vue?vue&type=script&lang=js"
export * from "./Festival.vue?vue&type=script&lang=js"
import style0 from "./Festival.vue?vue&type=style&index=0&id=423b0d31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423b0d31",
  null
  
)

export default component.exports